const initialState = () => ({
  areMetafieldsSaving: false
})

export default {
  namespaced: true,
  state: initialState(),
  
  mutations: {
    SET_METAFIELDS_SAVING (state, bool) {
      state.areMetafieldsSaving = bool
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/loaders.js